import { Location } from 'model';
import { WebOffer } from 'model/model.web-offer';
import { WebOfferSummary } from 'model/model.web-offer-summary';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

/**
 * Get the canonical `offer` URL for a given `origin` and `locale`
 *
 * @param origin - base URL for the canonical link
 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer canonical URL
 */
export function getCanonicalUrl(
  origin: string,
  offer: WebOffer | WebOfferSummary,
  locale?: string
): string {
  return `${origin}/${locale}${getAppUrl(
    APP_URLS.jobOffer,
    locale
  )}${getOfferUrl(offer, locale)}`;
}

/**
 * Get the `offer` URL for a given `locale`
 *

 * @param offer - (server-side model) to get the title from
 * @param locale - in which `Multilingual` server-side data will be retrieved
 * @returns  The offer  URL
 */
export function getOfferUrl(
  offer: WebOffer | WebOfferSummary,
  locale?: string
): string {
  const slug = offer.slug;

  return `/${offer.id}/${slug}`;
}

function cleanLocations(location: string): string {
  return location.replace(', España', '').replace(', Spain', '');
}

const LOCATIONS_SEPARATOR = ', ';

export function getCityStringFromUIPlacesAutocompleteItem(
  locations?: Location[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _locale?: string
): string {
  return (
    locations
      ?.map((location) => location?.displayName || '')
      .filter(Boolean)
      .map(cleanLocations)
      .join(LOCATIONS_SEPARATOR) || ''
  );
}

export type UILocationsSummary = {
  trimmedCount: number;
  trimmedCities: string[];
  trimmedCitiesStr: string;
  extraCount: number;
  extraCities: string[];
  extraCitiesStr: string;
};
